'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterableTagIds = exports.isFilterable = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFilterable = exports.isFilterable = function isFilterable(filter) {
  return typeof filter.filterable === 'boolean' ? filter.filterable : true;
};

var getFilterableTagIds = exports.getFilterableTagIds = function getFilterableTagIds(filters) {
  var filterId = (0, _keys2.default)(filters);
  return filterId.filter(function (id) {
    return filters[id].filterable;
  });
};